// extracted by mini-css-extract-plugin
export default {"indicator":"jLUO1q6VYVPDCc7XiFv2"};